import { BaseDaneService } from "../base/baseApiDane";

export class DaneServices extends BaseDaneService {

  async guardarUsuario(data: any) {
    try {
      const  response  = await this.axiosClient.post(`${process.env.REACT_APP_SERVER_USERS}users/`, data);
      return response;
    } catch (error) {
      throw new Error(`An unhandled exception in guardarUsuario with stack: ${error}`);
    }
  }

  async cambiarContraseniaUsuario(data: any) {
    try {
      const  response  = await this.axiosClient.post(`${process.env.REACT_APP_SERVER_USERS}users/change-password`, data);
      return response;
    } catch (error) {
      throw new Error(`An unhandled exception in cambiarContraseniaUsuario with stack: ${error}`);
    }
  }

  async recuperarContrasenia(data: any) {
    try {
      const  response  = await this.axiosClient.post(`${process.env.REACT_APP_SERVER_USERS}users/recoverPassword`, data);
      return response;
    } catch (error) {
      throw new Error(`An unhandled exception in cambiarContraseniaUsuario with stack: ${error}`);
    }
  }

  async obtenerUsuario(data: any) {
    try {
      const  response  = await this.axiosClient.get(`${process.env.REACT_APP_SERVER_USERS}`, data);
      return response;
    } catch (error) {
      throw new Error(`An unhandled exception in obtenerUsuario with stack: ${error}`);
    }
  }


 

}

export default new DaneServices();
